import { red } from "./red.js";
import { interleave } from "./utils.js";
const violet = (opts) => interleave(red(opts), red(opts));
export {
  violet
};
